<template>
  <div class="pa-2">
    <div v-if="value">
      <div v-for="(field, index) in value" :key="index">
        <template v-if="showItem(field)">
          <div v-if="field.data_type == 'editor'">
            <span>{{ field.label }}</span>
            <tiptap-editor
              :value="field.value"
              outlined
              v-model="field.value"
              :disabled="false"
            ></tiptap-editor>
          </div>
          <div v-else-if="field.data_type == 'checkbox'">
            <v-checkbox
              dense
              hide-details
              v-model="field.value"
              :label="field.label"
              :disabled="disabled"
            ></v-checkbox>
          </div>
          <div v-else-if="field.data_type == 'radio'">
            <v-radio-group dense v-model="field.value" :disabled="disabled">
              <template #label>
                <div class="text-right bold">
                  {{ field.label }}
                </div>
              </template>
              <v-radio
                v-for="option in field.data_info.options"
                :key="option.value"
                :value="option.value"
                :label="option.label"
              ></v-radio>
            </v-radio-group>
          </div>
          <div v-else-if="field.data_type == 'file'">
            <span>{{ field.label }}</span>
            <div v-if="field.value">
              <span v-if="field.file">
                <a :href="field.file.url" target="_blank">
                  {{ field.file.name }}
                </a>
                <v-icon small :disabled="disabled" @click="deleteFile(field, field.file)">
                  mdi-delete
                </v-icon>
              </span>
            </div>
            <div v-else-if="!disabled">
              <template v-if="field.data_info && field.data_info.alert && field.data_info.alert.text">
                <v-alert dense :type="field.data_info.alert.type ?? 'info'" text class="mt-1">
                  <span v-html="field.data_info.alert.text"></span>
                </v-alert>
              </template>
              <FileUpload
                v-if="!field.value"
                :path="`/upload-file-share-model/hrms_files/StaffFile`"
                :more-details="{ path: 'leave_documents' }"
                @uploaded="
                  file => ((field.value = file.id), (field.file = file), $emit('save'))
                "
              ></FileUpload>
            </div>
          </div>
          <div v-else-if="field.data_type == 'select'">
            <span>{{ field.label }}</span>
            <CustomSelect
              v-if="field.data_info"
              v-model="field.value"
              :url="field.data_info.url"
              :item-text="field.data_info.label"
              :item-value="field.data_info.value"
              :multiple="field.data_info.multiple"
              :disabled="disabled"
            ></CustomSelect>
          </div>

          <!-- date picker -->
          <div v-else-if="field.data_type == 'datepicker'">
            <span>{{ field.label }}</span>
            <date-picker
              class="english"
              v-model="field.value"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              :disabled="disabled"
              style="width: 100%;"
            ></date-picker>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="english text-left" dir="ltr">
      No block definitions found, If there should be one, please contact IT.
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import CustomSelect from '../util/CustomSelect.vue'
import FileUpload from '../util/file_upload/FileShareUpload.vue'
import TiptapEditor from '../util/NewTiptapEditor.vue'
import NewSelect from '../util/new_select/NewSelect.vue'

export default {
  data: () => ({}),
  components: { TiptapEditor, NewSelect, CustomSelect, FileUpload },
  props: ['value', 'itemId', 'model', 'disabled'],
  emits: ['input', 'save'],

  watch: {
    value: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true,
    },
  },

  methods: {
    showItem(field) {
      // if (!field.data_info?.relation) return true
      // for (let key in field.data_info.relation) {
      //   let related = this.value.find(v => v.id == key)
      //   if (related.value != field.data_info.relation[key]) return false
      // }
      if(!field.data_info?.show_if_relation) return true
      for (let key in field.data_info.show_if_relation){
        let related = this.value.find(v => v.id == key)
        if(!related) {
          alert('Undefined related field')
          return false
        }
        let cmp = field.data_info.show_if_relation[key].compare || 'eq'
        switch(cmp){
          case 'eq':
            if(related.value != field.data_info.show_if_relation[key].value) return false
            break;
          case 'in':
            if(!field.data_info.show_if_relation[key].value.includes(related.value)) return false
            break;
          default: alert('Undefined comparision type');
        }
      }
      return true
    },
    deleteFile(field, file) {
      swal({
        title: 'Are you sure?',
        text: 'This action cannot be reversed!',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(value => {
        if (value) {
          field.value = field.file = null
          this.$emit('save')
          return this.$axios.delete(`/api/files/${file.id}`)
        }
      })
    },
  },
}
</script>